import { Component, OnInit, ViewChild } from '@angular/core'
import { PlanODataService, IPlan } from '@exchange/domain/.'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import {
  ActionButtonsColumnRendererComponent,
  ConfirmModalComponent,
  GridWrapperComponent,
  LookupFilterComponent,
  Option
} from 'common-components'
import { BsModalService } from 'ngx-bootstrap/modal'
import { DateTimeColumnRendererComponent } from '../../shared/controls/grid-renderer/date-time-column.renderer.component'

@Component({
  selector: 'app-plans-list',
  templateUrl: './plans-list.component.html',
  standalone: false
})
export class PlansListComponent implements OnInit {
  model: IPlan = null
  states: Option[] = []

  @ViewChild('grid', { static: true }) grid: GridWrapperComponent

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private odata: PlanODataService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeGrid()

    const sm = this.route.snapshot.queryParams['successMessage']
    if (sm) {
      this.toastr.success(sm)
    }
  }

  addEntity(): void {
    this.router.navigate(['/system', 'plans', 0])
  }

  editClicked(data) {
    const model = data as IPlan
    this.router.navigate(['/system', 'plans', model.Id])
  }

  deleteClicked(data) {
    this.model = data as IPlan
    this.modalService
      .show(ConfirmModalComponent, {
        initialState: {
          title: `Delete Plan?`,
          message: `Are you sure you want to delete the selected Plan?`
        }
      })
      .content.onClose.subscribe(userConfirm => userConfirm && this.deleteModel())
  }

  deleteModel(): void {
    this.odata
      .delete(this.model.Id)
      .exec()
      .subscribe(response => this.grid.getData())
  }

  initializeGrid() {
    this.grid.defaultExpand = 'LineOfBusiness, Payer'

    this.grid.gridOptions.context = {
      canEdit: true,
      canDelete: true,
      editHandler: this.editClicked.bind(this),
      deleteHandler: this.deleteClicked.bind(this),
      overrideTimeZone: 'US/Eastern'
    }
    this.grid.frameworkComponents = { lookupFilter: LookupFilterComponent }
    this.grid.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'CHI Plan ID',
        field: 'Id',
        width: 75,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Payer',
        field: 'Payer.Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'LOB',
        field: 'LineOfBusiness.Value',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Last Modified By',
        field: 'ModifiedByFullName',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Modified On',
        field: 'ModifiedOn',
        width: 100,
        filter: 'agDateColumnFilter',
        cellRenderer: DateTimeColumnRendererComponent,
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.grid.odata = this.odata
  }
}
